import axios from "axios";

const API = axios.create({
  baseURL: "https://ecommerce-app-2-5cgz.onrender.com/api",
});

export const fetchProducts = () => API.get("/products");
export const fetchProductById = (id) => API.get(`/products/${id}`);
export const createOrder = (orderData) => API.post("/orders", orderData);